$(function(){

    var $menuLink = $('.menu a');
    var _clientY = null; // remember Y position on touch start

    $menuLink.on('click', function(e){
        e.preventDefault();
        var $this = $(this);

        $this.toggleClass('active');

        $.ajax({
            type: 'POST',
            url: Ajax.ajaxurl,
            data: {
                action: 'pull_content',
                page: $this.attr('href')
            },
            success: function(data){

                var post = JSON.parse(data);

                Swal.fire({
                    titleText: post.post_title,
                    html: post.post_content,
                    width: '1200px',
                    showConfirmButton: false,
                    showCloseButton: true,
                    closeButtonHtml: '<i class="fas fa-times"></i> Close',
                    customClass: {
                        popup: 'sda-popup',
                        title: 'sda-popup-title',
                        closeButton: 'sda-popup-close',
                        htmlContainer: 'sda-popup-content',
                    }
                });

                $('.sda-popup-close').after('<div class="sda-popup-content-container">');
                $('.swal2-progress-steps, .swal2-icon, .swal2-image, .sda-popup-title, .sda-popup-content').detach().appendTo('.sda-popup-content-container');

                if(Swal.isVisible()) {
                    $('#user_login').attr('placeholder', 'Your email address...');
                    $('#user_pass').attr('placeholder', 'Your password...');
                    $('.login-submit input[type="submit"]').remove();
                    $('.login-submit').prepend('<button type="submit" name="wp-submit" id="wp-submit" class="button button-primary">Log in <i class="fas fa-chevron-right"></i></button>');

                    var  popup = document.querySelector('.sda-popup-content-container');

                    popup.addEventListener('touchstart', function (event) {
                        if (event.targetTouches.length === 1) {
                        // detect single touch
                            _clientY = event.targetTouches[0].clientY;
                        }
                    }, false);
                    
                    popup.addEventListener('touchmove', function (event) {
                        
                        if (event.targetTouches.length === 1) {
                            // detect single touch
                            disableRubberBand(event, popup);
                        }

                        if (event.targetTouches[0].clientY > _clientY) {
                            popup.scrollTop -= 40;
                        } else {
                            popup.scrollTop += 40;
                        }

                    }, false);

                }
            }
        })
    });
    
      function disableRubberBand(event, container) {
        var clientY = event.targetTouches[0].clientY - _clientY;
    
        if (container.scrollTop === 0 && clientY > 0) {
          // element is at the top of its scroll
          event.preventDefault();
        }
    
        if (isOverlayTotallyScrolled(container) && clientY < 0) {
          //element is at the top of its scroll
          event.preventDefault();
        }
      }
    
      function isOverlayTotallyScrolled(container) {
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
        return container.scrollHeight - container.scrollTop <= container.clientHeight;
      }
    
});